import { proxy } from "valtio";
import type { EnvType } from "~/config/env.server";
import type { settingsSchemaType } from "~/modules/dashboard/settings/settings-session";
import type { Organization } from "@prisma/client";
import type { Workspace } from "@prisma/client";

type userSettingsType = Omit<settingsSchemaType, "language">;
export const commonState = proxy<{
  ENV: { APP_ENV: EnvType["APP_ENV"] };
  settingsSession: userSettingsType;
  toast: { message: string; tone: "danger" | "success" } | null;
}>({
  ENV: { APP_ENV: "production" },
  settingsSession: { isSidebarOpen: false },
  toast: null,
});

export const dashboardState = proxy<{
  workspaces: (Pick<Workspace, "id" | "name"> & { logoUrl: string | null })[];
  accessibleOrganizations: Pick<Organization, "id" | "name">[];
  selectedWorkspaceId: string;
  selectedOrganizationId: string;
  logoUrl: string | null;
  allowedModules: string[];
  clientLocale: string;
  isSuperUser: boolean;
  isOrgAdmin: boolean;
  /** Super users, org admins, and users with more than one organization or workspace. */
  canViewCcDashboard: boolean;
  isPoc: boolean;
}>({
  workspaces: [],
  accessibleOrganizations: [],
  selectedWorkspaceId: "",
  selectedOrganizationId: "",
  allowedModules: [],
  logoUrl: null,
  clientLocale: "en-GB",
  isSuperUser: false,
  isOrgAdmin: false,
  canViewCcDashboard: false,
  isPoc: false,
});
